import { T } from '@app/components/translation';
import Button from '@app/components/button';

import style from './constants.module.scss';

type ExternalSupportLinkProps = {
  link: string;
  location?: 'document' | 'template';
  type: 'comments' | 'suggestions';
};

const SupportLink = {
  comments: {
    text: (
      <T
        _str="comments"
        _comment="Link to the comments support article."
      />
    ),
    event: 'Go To Inline Comment Support',
  },
  suggestions: {
    text: (
      <T
        _str="suggest"
        _comment="Link to the suggestions support article."
      />
    ),
    event: 'Go To Suggestions Support',
  },
};

export const ExternalSupportLink: React.FC<ExternalSupportLinkProps> = ({
  link,
  location,
  type,
}) => (
  <Button
    kind="link"
    href={link}
    className={style.Link}
    trackable={{
      name: SupportLink[type].event,
      props: {
        location: location ? `${location} - collaboration menu` : undefined,
      },
    }}
    external
    target="_blank"
    rel="noopener noreferrer"
  >
    {SupportLink[type].text}
  </Button>
);
